import { Report1916Container } from "../../../containers/borrowSystem/Report/Report1916Container";

export function Report1916Page() {
    return (
        <Report1916Container />
    )
}